import { NotificationService } from "../../api/notification-service";
import { EOSService } from "../../api/eos-service";

const state = {};

const getters = {};

const actions = {
    async AddSubscription(state, { AddSubscriptionData }) {
        var perno = state.rootState.auth.auth.username;
        var data = {
            Endpoint: AddSubscriptionData.endpoint,
            p256dh: AddSubscriptionData.p256dh,
            auth: AddSubscriptionData.auth,
            EmployeeId: perno
        }
        return await EOSService.makeRequest(NotificationService.AddSubscription(data))
    },
    async SendNotification(state, { SendNotificationParams }) {
        var params = {
            senderPerno: SendNotificationParams.senderPerno,
            recieverPerno: SendNotificationParams.recieverPerno,
            RequestType: SendNotificationParams.RequestType,
            requestState: SendNotificationParams.requestState,
            date: SendNotificationParams.date,
            time: SendNotificationParams.time,
        }
        return await EOSService.makeRequest(NotificationService.SendNotification(params))
    },
    async SendNotificationForManager(state, { params }) {
        var _params = {
            personelPerno: params.personelPerno,
            pageNo: params.pageNo,
            code: params.code,//کد مرخصی یا ماموریت - برای اضافه کار و ورود و خروج مقدار -1
            RequestType: params.RequestType,
            date: params.date,
            time: params.time,
        }
        return await EOSService.makeRequest(NotificationService.SendNotificationForManager(_params))
    },
};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
}